import { useSelector } from "react-redux";

import { TAppState } from "store/root.store";

export const useAltQuotesSelector = () => useSelector((state: TAppState) => state.altQuotesReducer);
